import axios from 'axios'
import { stringify } from 'query-string'

export const getProductFavorites = () => {
  return axios.get('/pos/products/favorites')
}

export const createProductFavorites = (payload) => {
  return axios.post('/pos/products/favorites', payload)
}

export const deleteProductFavorites = ({ id }) => {
  return axios.delete(`/pos/products/favorites/${id}`)
}

export const moveProductFavorite = ({ id, payload }) => {
  return axios.patch(`/pos/products/favorites/${id}/move`, payload)
}

export const getOutlets = ({ payload }) => {
  const query = stringify(payload)
  return axios.get(`/pos/outlets?${query}`)
}

export const createOutlet = ({ payload }) => {
  return axios.post('/pos/outlets', payload)
}

export const editOutlet = ({ id, payload }) => {
  return axios.put(`/pos/outlets/${id}`, payload)
}

export const deleteOutlet = ({ id }) => {
  return axios.delete(`/pos/outlets/${id}`)
}

export const getPosUsers = () => {
  return axios.get('/pos/users')
}

export const outletFloors = ({ payload }) => {
  const { id, ...restPayload } = payload
  const query = stringify(restPayload)
  return axios.get(`/pos/outlets/${id}/floors?${query}`)
}

export const addFloor = ({ id, payload }) => {
  return axios.post(`/pos/outlets/${id}/floors`, payload)
}

export const deleteFloor = ({ outletId, roomId }) => {
  return axios.delete(`/pos/outlets/${outletId}/floors/${roomId}`)
}

export const editFloor = ({ outletId, roomId, body }) => {
  return axios.patch(`/pos/outlets/${outletId}/floors/${roomId}`, body)
}

// Reset satu meja terpilih (BE: is_finish=1 + status_id=RESET). Order tidak dihapus, hanya dilepas.
export const resetOrderTablesByTable = ({ payload }) => {
  return axios.patch('/pos/orderTables/resetByTable', payload)
}

// Reset semua meja terpakai pada satu lantai/ruangan.
export const resetOrderTablesByRoom = ({ payload }) => {
  return axios.patch('/pos/orderTables/resetByRoom', payload)
}

export const getPosRoles = () => {
  return axios.get('/pos/roles')
}

export const editPosRole = ({ id, payload }) => {
  return axios.patch(`/pos/roles/${id}`, payload)
}

export const getPosOjols = ({ payload }) => {
  const query = stringify(payload)
  return axios.get(`/pos/ojols?${query}`)
}

export const addPosOjol = ({ payload }) => {
  return axios.post('/pos/ojols', payload)
}

export const getPosOjolsById = ({ id }) => {
  return axios.get(`/pos/ojols/${id}`)
}

export const editPosOjol = ({ id, payload }) => {
  return axios.put(`/pos/ojols/${id}`, payload)
}

export const deletePosOjol = ({ id }) => {
  return axios.delete(`/pos/ojols/${id}`)
}

export const getPosOutletDetail = ({ id }) => {
  return axios.get(`/pos/outlets/${id}`)
}

export const getSuggestionOutlet = (params, options) => {
  return axios.get('/pos/outlets', { params, ...options })
}
export const getSuggestionOjols = (params, options) => {
  return axios.get('/pos/ojols', { params, ...options })
}

export const getPosShifts = (params) => {
  return axios.get('pos/shifts', { params })
}

export const exportPosShifts = async (params) => {
  const response = await axios.get('pos/shifts', { params, responseType: 'arraybuffer' })

  if (response.headers['content-type']?.includes('application/json')) {
    throw new Error('Export failed')
  }

  return response
}

export const getPosShiftDetail = (id) => {
  return axios.get(`pos/shifts/${id}`)
}

export const getPosSalesByPaymentType = (params) => {
  return axios.get('pos/reportings/salesByPaymentType', { params })
}

export const getPosSalesByPaymentTypeDetail = (params) => {
  const { paymentTypeId, ...restParams } = params
  return axios.get(`pos/reportings/salesByPaymentType/${paymentTypeId}`, { params: restParams })
}

export const getPosOrders = (params) => {
  return axios.get('pos/orders', { params })
}

export const getPosOrder = (id) => {
  return axios.get(`pos/orders/${id}`)
}

export const getPosOrderSummary = (params) => {
  return axios.get('pos/orders/summary', { params })
}

export const getPosSalesByInvoiceTypes = (params) => {
  return axios.get('pos/reportings/salesByInvoiceType', { params })
}

export const getPosSalesByInvoiceType = (params) => {
  const { id, ...restParams } = params
  return axios.get(`pos/reportings/salesByInvoiceType/${id}`, { params: restParams })
}

export const getPosSalesDetail = (params) => {
  return axios.get('pos/reportings/salesDetail', { params })
}

export const exportPosSalesDetail = (params) => {
  return axios.get('pos/reportings/salesDetail', { params, responseType: 'arraybuffer' })
}

export const getPosSalesDetailSummary = (params) => {
  return axios.get('pos/reportings/salesDetail/summary', { params })
}

export const getPosSalesPriceRule = (params) => {
  return axios.get('pos/reportings/salesPriceRule', { params })
}

export const getPosSalesPriceRuleTransactions = (params) => {
  const { priceRuleId, ...restParams } = params
  return axios.get(`pos/reportings/salesPriceRule/${priceRuleId}/transactions`, {
    params: restParams,
  })
}

export const createQRCodePayment = (payload, config = {}) => {
  return axios.post('/pos/payment/qrcode', payload, config)
}

export const createPaymentGateway = (payload, config = {}) => {
  return axios.post('/pos/payment/paymentGateway', payload, config)
}

export const createPosInvoice = (payload, config = {}) => {
  return axios.post('/pos/invoices', payload, config)
}

export const payPosOrder = (id, payload, config = {}) => {
  return axios.post(`/pos/orders/${id}/pay`, payload, config)
}

export const sendEmailOrderBill = (params, config = {}) => {
  return axios.post(
    `/pos/orders/${params.id}/emailEOrder`,
    {
      mail_to: params.mail_to,
      is_web_pos: 1,
    },
    config,
  )
}

export const changePin = (payload, config = {}) => {
  return axios.put(`/pos/users/${payload?.id}/pin`, payload, config)
}

export const verifyPin = (payload, config = {}) => {
  return axios.post(`/pos/users/${payload?.id}/verify-pin`, { pin: payload.pin }, config)
}

/**
 * QZ Tray Certificate & Signing APIs
 * Based on QZ Tray signing documentation: https://qz.io/docs/signing
 */

/**
 * Get QZ Tray certificate
 * @returns {Promise<string>} Certificate string in PEM format
 */
export const getQZTrayCertificate = () => {
  return axios.get(`${import.meta.env.VITE_INVOICE_URL}/qz-sign/certificate`, {
    responseType: 'text',
    headers: {
      'Content-Type': 'text/plain',
    },
  })
}

/**
 * Sign message for QZ Tray
 * @param {string} request - Message to sign
 * @returns {Promise<string>} Base64 encoded signature
 */
export const signQZTrayMessage = (request) => {
  return axios.get(`${import.meta.env.VITE_INVOICE_URL}/qz-sign/signature`, {
    params: { request },
    responseType: 'text',
    headers: {
      'Content-Type': 'text/plain',
    },
  })
}

export const getPosCashierWidget = (params, config = {}) => {
  return axios.get('pos/cashier/cashWidget', { params, ...config })
}

export const addPosReturn = (payload, config = {}) => {
  return axios.post('/pos/returns', payload, config)
}

export const getPosCashierCashInOut = (params, config = {}) => {
  return axios.get('pos/cashier/cashInOut', { params, ...config })
}

// Kiriman ke layar pelanggan berjalan di latar belakang: gagal/lambat tidak boleh menyela kasir
// (tanpa toast & modal no-internet; pemanggil menampilkan errornya sendiri bila perlu).
const POS_DISPLAY_BROADCAST_CONFIG = {
  skipErrorNotification: true,
  silentOffline: true,
  timeout: 10000,
}

export const posDisplayBroadcast = (payload) => {
  return axios.post('/pos/display/broadcast', payload, POS_DISPLAY_BROADCAST_CONFIG)
}

// Media promo layar pelanggan (per outlet)
export const getPosDisplayMedia = (outletId, config = {}) => {
  return axios.get(`/pos/outlets/${outletId}/displayMedia`, config)
}

export const uploadPosDisplayMedia = (outletId, form, config = {}) => {
  return axios.postForm(`/pos/outlets/${outletId}/displayMedia`, form, config)
}

export const updatePosDisplayMedia = (outletId, mediaId, payload) => {
  return axios.patch(`/pos/outlets/${outletId}/displayMedia/${mediaId}`, payload)
}

export const activatePosDisplayMedia = (outletId, mediaId) => {
  return axios.patch(`/pos/outlets/${outletId}/displayMedia/${mediaId}/activate`)
}

export const deactivatePosDisplayMedia = (outletId, mediaId) => {
  return axios.patch(`/pos/outlets/${outletId}/displayMedia/${mediaId}/deactivate`)
}

export const movePosDisplayMedia = (outletId, mediaId, payload) => {
  return axios.patch(`/pos/outlets/${outletId}/displayMedia/${mediaId}/move`, payload)
}

export const deletePosDisplayMedia = (outletId, mediaId) => {
  return axios.delete(`/pos/outlets/${outletId}/displayMedia/${mediaId}`)
}
